import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/config';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(collection(db, 'brands'));
        const all = snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(b => b.active);
        setBrands(all);
      } catch { setBrands([]); }
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <div className="home-page">
      {/* Header */}
      <header className="home-header">
        <div className="container home-header-inner">
          <div className="home-logo">
            <img src="/cateringco-logo.png" alt="CateringCo" className="home-logo-img" />
            <div className="home-logo-text-block">
              <div className="home-logo-name">CATERINGCO</div>
              <div className="home-logo-sub">Australia's Catering Enquiry Platform</div>
            </div>
          </div>
          <nav className="home-header-nav">
            <span className="home-header-nav-item">🇦🇺 Australian Brands</span>
            <span className="home-header-nav-item">Fast Enquiries</span>
            <span className="home-header-nav-item">No Account Needed</span>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="home-hero">
        <div className="container home-hero-content">
          <div className="home-hero-left">
            <div className="home-hero-eyebrow">
              <div className="home-eyebrow-line" />
              <span>Australia's Catering Enquiry Platform</span>
            </div>
            <h1 className="home-hero-title">FIND YOUR<br /><span className="home-hero-outline">CATERER.</span></h1>
            <p className="home-hero-sub">Browse top Australian food brands and submit your catering enquiry in minutes. No account needed.</p>
            <div className="home-hero-stats">
              <div className="home-hero-stat">
                <span className="home-hero-stat-num">{brands.length || '—'}</span>
                <span className="home-hero-stat-label">Brands Listed</span>
              </div>
              <div className="home-hero-stat">
                <span className="home-hero-stat-num">3</span>
                <span className="home-hero-stat-label">Steps to Enquire</span>
              </div>
              <div className="home-hero-stat">
                <span className="home-hero-stat-num">0</span>
                <span className="home-hero-stat-label">Accounts Needed</span>
              </div>
            </div>
          </div>
          <div className="home-hero-right">
            <div className="home-hero-badge">
              <span className="home-hero-badge-icon">🍱</span>
              <div className="home-hero-badge-text">
                <strong>Browse the Menu</strong>
                Pick items for your event
              </div>
            </div>
            <div className="home-hero-badge">
              <span className="home-hero-badge-icon">📋</span>
              <div className="home-hero-badge-text">
                <strong>Add to Enquiry</strong>
                Build your catering list
              </div>
            </div>
            <div className="home-hero-badge">
              <span className="home-hero-badge-icon">✅</span>
              <div className="home-hero-badge-text">
                <strong>Submit & We'll Call</strong>
                Fast response guaranteed
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brands */}
      <section className="home-brands">
        <div className="container">
          <div className="home-brands-header">
            <div className="home-brands-header-left">
              <p className="home-brands-count">{brands.length} brand{brands.length !== 1 ? 's' : ''} available</p>
              <h2 className="home-brands-title">OUR BRANDS</h2>
              <p className="home-brands-desc">Click any brand to browse their menu and start an enquiry</p>
            </div>
          </div>

          {loading ? (
            <div className="brands-grid">
              {[1,2,3,4].map(i => <div key={i} className="brand-skeleton" />)}
            </div>
          ) : brands.length === 0 ? (
            <div className="brands-empty">
              <h3>Coming Soon</h3>
              <p>Our catering partners are being set up. Check back soon!</p>
            </div>
          ) : (
            <div className="brands-grid">
              {brands.map(brand => (
                <div key={brand.id} className="brand-card" onClick={() => navigate(`/${brand.id}`)}
                  style={{ '--card-color': brand.primaryColor || '#111' }}>
                  <div className="brand-card-top" style={{ background: brand.primaryColor || '#111' }}>
                    {brand.logoUrl ? (
                      <img src={brand.logoUrl} alt={brand.name} className="brand-card-logo" />
                    ) : (
                      <div className="brand-card-initials">{brand.name?.slice(0,2).toUpperCase()}</div>
                    )}
                  </div>
                  <div className="brand-card-body">
                    <h3 className="brand-card-name">{brand.name}</h3>
                    <p className="brand-card-tagline">{brand.tagline || 'Fresh catering for every occasion'}</p>
                    <div className="brand-card-footer">
                      <span className="brand-card-cta">Order Now →</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="home-footer">
        <div className="container home-footer-inner">
          <p className="home-footer-copy">© {new Date().getFullYear()} CateringCo. All rights reserved.</p>
          <a href="/superadmin/login" className="home-footer-admin">Platform Admin</a>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
